export const getPaymentAmount = (totalInCents: number | undefined): number =>
  Math.max(0, totalInCents || 0)
